import '@naturalcycles/ncuikit/dist/ButtonLink.css'
import { _isNotNullish } from '@naturalcycles/js-lib'
import { ButtonLink, ButtonLinkProps } from '@naturalcycles/ncuikit'
import { addQueryStringAndNavigate } from '@src/helpers/signupUrl'
import { useSignupHref } from '@src/hooks/useSignupHref'
import type { PropsWithChildren, ReactElement } from 'react'
import { useCallback } from 'react'

/**
 * TODO:
 * This component should be refactored so that it doesn't prevent default browser behaviour on click.
 * Everything that we do (compute href, add query params, utms, etc) should be done beforehand so that the final URL is provided to the button/link
 * and it is not necessary anymore to prevent default behaviour.
 *
 * - there is an exception: when a "customClickHandler" is provided. At current time this is provided only ONCE in the entire codebase (PopupOfferCampaign.component.tsx)
 * - event tracking should also be done "at destination" (i.e. in the web signup page) instead of here. WebSignup can track which button has been clicked on NCWeb based on utm parames added to the URL (see ncUtmSource)
 * - code that depends on CookieBot (eg. window.Cookiebot?.hasResponse) should listen to cookiebot events (CookiebotOnLoad) and perform actions when event is triggered
 *
 * A partial refactory has been done on Apr 22 2025, but did not go all the way as it is outside of the scope of the task.
 */

interface SignupButtonProps
  extends PropsWithChildren,
    // "onAfterClickAndRedirect" and "href" are computed within the component
    // "target" is not supported
    Omit<ButtonLinkProps, 'onAfterClickAndRedirect' | 'href' | 'target'> {
  ignoreConfirmation?: boolean
  code?: string
  utmTrackingId?: string
}

export function SignupButton({
  id,
  uid,
  variant,
  mode,
  size,
  icon,
  hasIconLeft,
  isWide,
  ariaLabel = 'Signup',
  isDisabled,
  children,
  ignoreConfirmation,
  code: codeProp,
  utmTrackingId,
}: SignupButtonProps): ReactElement {
  const { href } = useSignupHref(codeProp, ignoreConfirmation)

  // TODO: no need to be async, but onAfterClickAndRedirect type requires it (for now)
  const onAfterClickAndRedirect = useCallback(async (): Promise<void> => {
    addQueryStringAndNavigate(href, utmTrackingId)
  }, [utmTrackingId, href])

  const props: ButtonLinkProps = {
    id,
    uid,
    variant,
    mode,
    size,
    icon,
    hasIconLeft,
    isWide,
    ariaLabel,
    isDisabled,
    href,
    onAfterClickAndRedirect,
  }

  return (
    <>
      {href && _isNotNullish(children) && (
        // Signup button should be ClientOnly to avoid hydration issues, but we need it not to be for
        // tests right now. Todo: Move the signup button tests to be e2e tests.
        <ButtonLink {...props}>{children}</ButtonLink>
      )}
      {/* Placeholder for CLS */}
      {!href && <div style={{ height: '46px', width: '100%' }} />}
    </>
  )
}
